export default __webpack_public_path__ + "static/media/active-campaign-label.eaf14190.png";